const trans = {
  Ticket: "التذكرة",
  "Write a message…": "اكتب رسالة…",
  //   Send: "إرسال",
  "No description": "لا يوجد وصف",
  "No messages yet": "لا توجد رسائل بعد",
  //   Created: "تاريخ الإنشاء",
  "Last activity": "آخر نشاط",
  //   Status: "الحالة",
  //   Refresh: "تحديث",
  Topic: "الموضوع",
  "Select a topic": "اختر موضوعًا",
  "Sub-topic": "موضوع فرعي",
  "Select a sub-topic": "اختر موضوعًا فرعيًا",
  "Request Type": "نوع الطلب",
  "Description (describe your issue in great detail)":
    "الوصف (صف مشكلتك بالتفصيل)",
  "Describe the problem, steps to reproduce, and impact…":
    "صف المشكلة، وخطوات إعادة إنتاجها، والأثر…",
  //   Priority: "الأولوية",
  "Select priority": "اختر أولوية",
  "First Response": "الاستجابة الأولى",
  "Submit on behalf of": "تقديم بالنيابة عن",
  //   "Select a user": "اختر مستخدمًا",
  //   Close: "إغلاق",
  //   Submit: "تقديم",
  "Submit a request": "تقديم طلب",
  "New request": "طلب جديد",
  "My requests": "طلباتي",
  //   SomethingWentWrong: "حدث خطأ ما",
  Accepted: "تم القبول",
  "Under Review": "قيد المراجعة",
  Released: "تم الاطلاق",
  Rejected: "مرفوض",
  "In Progress": "قيد التنفيذ",
  Feature: "ميزة",
  "Something is broken": "هناك شيء لا يعمل",
  Low: "منخفض",
  Medium: "متوسط",
  High: "عالٍ",

  "Online store": "المتجر الإلكتروني",
  "Website performance": "أداء الموقع",
  "Website theme and design": "تصميم وقالب الموقع",
  "Website domain": "نطاق الموقع",
  "Products and categories": "المنتجات والتصنيفات",
  "Delivery time": "وقت التوصيل",
  Gifting: "الهدايا",
  "Options and modifiers": "الخيارات والإضافات",
  Variants: "الأنواع",
  "Order tracking": "تتبع الطلب",
  "Dashboard experience": "تجربة لوحة التحكم",
  "Dashboard performance": "أداء لوحة التحكم",
  "Order management": "إدارة الطلبات",
  Notifications: "الإشعارات",
  "Product management": "إدارة المنتجات",
  "Printing and invoices": "الطباعة والفواتير",
  "Driver management": "إدارة السائقين",

  "Customers and feedback": "العملاء والتغذية الراجعة",
  Addons: "الإضافات",
  "Branch management": "إدارة الفروع",
  "Payment integrations": "الربط مع شركات الدفع",
  "Delivery integrations": "الربط مع شركات التوصيل",
  "Social integrations": "الربط مع ادوات التسويق",
  "Inventory and POS integrations": "الربط مع شركات ادارة المخزون ونقاط الدفع",
  "Abandoned carts": "السلات المهملة",
  "Table ordering": "طلب الطاولة",
  "QR menus": "قوائم QR",
  "ordable/ manager": "تطبيق اوردبل/",
  "ordable/ driver app": "تطبيق اوردبل/ للسائق",
  Chat: "المحادثة",
  me: "أنا",
  "Attachments (optional)": "المرفقات (اختياري)",
  "Drop files here": "ضع الملفات هنا",
  "You can also paste images/files into the description box":
    "يمكنك ايضا لصق صور/ملفات في خانة الوصف",
  Uploaded: "تم الرفع",
  "Attachments (submitted with request)": "المرفقات (تم رفعها مع الطلب)",
  Attach: "اضف ملف/صورة",
  "I have a suggestion": "لديّ اقتراح",
  "Something is broken": "هناك شيء لا يعمل",
  Importance: "الأهمية",
  Fix: "تصليح",
  Comments: "التعليقات",
  Suggestion: "اقتراح",
  "How Can We Help?": "كيف يمكننا المساعدة؟",
  "Chat With Support": "الدردشة مع الدعم المباشر",
  "Get quick support or reach the right team.":
    "احصل على دعم سريع آو تواصل مع الفريق المناسب.",
  "Get instant help for urgent needs":
    "احصل على مساعدة فورية للاحتياجات العاجلة.",
  "Contact Your Account Manager": "طلب التواصل مع مسؤول حسابك",
  "Help with onboarding, billing, or your account.":
    "مساعدة في الانضمام، الفواتير، أو حسابك.",
  "Report A Technical Issue": "الابلاغ عن مشكلة تقنية",
  "Report bugs or request product improvements.":
    "الابلاغ عن الأخطاء أو طلب تحسينات على منتجنا.",
  "View Support Requests": "عرض طلبات الدعم.",
  "Track the status of your tickets.": "تتبع حالة تذاكرك.",
  "Visit Our Help Center": "قم بزيارة مركز المساعدة لدينا",
  "Find guides, tutorials, and FAQs.":
    "ابحث عن الأدلة والدروس والأسئلة الشائعة.",
  "How Would You Like To Chat?": "كيف تريد التواصل معنا؟",
  "LIVE CHAT ON WEB": "المحادثة الفورية",
  "GO TO WHATSAPP": "واتساب",
  "Support Request Form": "تقديم طلب مساعدة",
  "Get help with onboarding, billing, or your account.":
    "مساعدة في الانضمام، الفواتير، أو حسابك.",
  "What Do You Need Help with?": "اختر القسم الذي تحتاج المساعدة فيه:",
  "Choose a topic": "اختر الموضوع",
  "Onboarding & setup": "بدء الاستخدام والإعداد",
  "Billing & invoices": "الفوترة والفواتير",
  "Plan or pricing changes": "تغييرات الخطة أو الأسعار",
  "Account settings": "إعدادات الحساب",
  "Business advice": "استشارات أعمال",
  "Something else": "آخر",
  "Tell us what you need help with...": "اخبرنا بما تحتاج المساعدة فيه...",
  "Include details on steps, error messages, or examples help us fix this faster.":
    "اذكر تفاصيل الخطوات، ورسائل الأخطاء، أو أمثلة تساعدنا على حل المشكلة بشكل أسرع.",
  "Attachments (Optional)": "المرفقات (اختياري)",
  "Drop Files Here": "اسحب الملفات هنا",
  "You can also paste images/files into the description box.":
    "يمكنك أيضًا لصق الصور/الملفات في مربع الوصف.",
  "Not Urgent": "غير عاجل",
  "Soon, Please": "قريبًا، من فضلك",
  Urgent: "عاجل",
  "SEND REQUEST": "إرسال الطلب",
  "Technical Issue Form": "تقديم طلب دعم تقني",
  "Help us understand what’s not working.": "ساعدنا على فهم ما الذي لا يعمل.",
  "Issue Type": "نوع المشكلة",
  "Bug / Something isn’t working": "خلل / شيء لا يعمل",
  "Feature request / improvement": "طلب ميزة / تحسين",
  "Performance issue": "مشكلة أداء",
  "Integration issue": "مشكلة ربط",
  "Affected Area": "القسم المتأثر",
  "What happened? Please be as detailed as possible.":
    "ماذا حدث؟ يرجى ذكر التفاصيل قدر الإمكان.",
  "Not sure where to go? Start with": "لست متأكداً؟ ",
  "live chat": "ابدأ بالدردشة المباشرة",
  "Chat is disabled because this request is closed.":
    "تم تعطيل الدردشة لأن هذا الطلب مغلق.",
  "Chat disabled for closed requests.": "تم تعطيل الدردشة للطلبات المغلقة.",
  Technical: "تقني",
};

export default trans;
